<template>
  <b-card-body>
    <b-row>
      <b-col>
        <h5>{{ $t('question') }}</h5>
        <b-input-group style="margin-bottom: 25px;">
          <b-form-textarea :rows="1" v-model="question.text"></b-form-textarea>
        </b-input-group>

        <h5>{{ $t('questionalternative') }}</h5>
        <b-list-group v-for="(alternative, alternativeIndex) in question.alternatives" :key="alternative.id">
          <b-row>
          <b-col sm="12">
          <b-input-group style="margin-bottom: 5px;">
          <b-form-textarea style="width: 80%;" rows="1" v-model="alternative.text" />
          <b-form-input style="width: 10%;min-width:50px;" type="number" v-model="alternative.points" :disabled="!isDefaultLanguage"/>
          <b-input-group-append>
          <b-button v-if="isDefaultLanguage"
                    variant="danger"
                    @click.stop="deleteObjectFromCollection(question.alternatives, alternativeIndex)">
                    x
          </b-button>
          </b-input-group-append>
          </b-input-group>
          </b-col>
          </b-row>
        </b-list-group>

        <b-button ref="addAlternativeButton"
                  class="me-2"
                  style="margin-top: 5px;"
                  v-if="isDefaultLanguage"
                  @click.stop="addAlternative(question.alternatives)">
                  {{ $t('privatePage.scaleQuestionsAlternativeAdd') }}
        </b-button>

        <b-button ref="deleteQuestionButton"
          variant="danger"
          style="margin-top: 5px;"
          v-if="isDefaultLanguage && isPartOfCollection"
          @click.stop="$emit('onDeleteQuestion', questionIndex)">
          {{ $t('privatePage.scaleQuestionsDelete') }}
        </b-button>

      </b-col>
      <b-col v-if="!isDefaultLanguage">

        <h5>{{ $t('question') }}</h5>
        <b-input-group style="margin-bottom: 25px;">
          <b-form-textarea readonly rows="1" v-model="question.defaultText"></b-form-textarea>
        </b-input-group>

        <h5>{{ $t('questionalternative') }}</h5>
        <b-list-group v-for="alternative in question.alternatives" :key="alternative.id">
          <b-input-group style="margin-bottom: 5px;">
            <b-col sm="12" class="points">
              <b-form-textarea readonly rows="1" v-model="alternative.defaultText">
              </b-form-textarea>
            </b-col>
          </b-input-group>
        </b-list-group>
      </b-col>
    </b-row>
  </b-card-body>
</template>

<script>
import editorFuncs from '../questioneditorfuncs'

export default {
  name: 'bp-module',
  props: {
    question: {},
    questionIndex: 0,
    isDefaultLanguage: false,
    isPartOfCollection: false
  },
  methods: {
    deleteObjectFromCollection(collection, index) {
      editorFuncs.deleteObjectFromCollection(collection, index)
    },
    addAlternative() {
      editorFuncs.addAlternative(
        this.question.alternatives
      )
    }
  },
  created() {
    if (this.question.alternatives.length === 0) {
      this.addAlternative()
    }
  }
}
</script>

<style scoped>
.alternatives {
  padding: 0px 5px 0px 0px;
}

.points {
  padding: 0px;
  min-width: 50px;
}
</style>
